import { ChainSelectorsProvider } from 'modules/chains/components/ChainSelectorsProvider';

import { AddNetworkButton, AddNetworkButtonProps } from './AddNetworkButton';

export const AddNetworkButtonContainer = (props: AddNetworkButtonProps) => {
  return (
    <ChainSelectorsProvider chain={props.chain}>
      <AddNetworkButton {...props} />
    </ChainSelectorsProvider>
  );
};
